import React from "react";
import { CloudOutlined, VideoCameraOutlined, IdcardOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import { history } from "../../store";
import useRole from "../../hooks/useRole";

function getMenuItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const NavigationQSHub = ({ activeSubmenu, handleChangeSubmenu, activeKey }) => {
  const { isUser, isAdminOrSupport } = useRole();

  const items = [
    getMenuItem(
      <FormattedMessage id="NavigationQSHub.quickstreamHub" defaultMessage="Quickstream Hub" />,
      "/qs-hub",
      <CloudOutlined />,
      [
        ...(isUser
          ? [
              getMenuItem(
                <FormattedMessage id="NavigationQSHub.myOrganization" defaultMessage="My organization" />,
                "/qs-hub/organization",
                <IdcardOutlined />
              ),
            ]
          : []),
        ...(isAdminOrSupport
          ? [
              getMenuItem(
                <FormattedMessage id="NavigationQSHub.organizations" defaultMessage="Organizations" />,
                "/qs-hub/organizations",
                <IdcardOutlined />
              ),
            ]
          : []),
        getMenuItem(
          <FormattedMessage id="NavigationQSHub.hubChannels" defaultMessage="Hub channels" />,
          "/qs-hub/hub-channels",
          <VideoCameraOutlined />
        ),
      ]
    ),
  ];

  const handleChangeNav = (event) => {
    history.push(event.key);
  };

  return (
    <Menu
      onClick={handleChangeNav}
      mode="inline"
      items={items}
      theme="dark"
      openKeys={activeSubmenu}
      onOpenChange={handleChangeSubmenu}
      selectedKeys={activeKey}
    />
  );
};

NavigationQSHub.defaultProps = {
  activeSubmenu: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleChangeSubmenu: PropTypes.func.isRequired,
  activeKey: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default NavigationQSHub;
